import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { EmploymentQuery as EmploymentQueryType, EmploymentQueryVariables } from "./__generated__/EmploymentQuery";

const EmploymentQuery = loader("./EmploymentQuery.gql");

type EmploymentQueryProviderType = (props: {
  children: (data: EmploymentQueryType) => ReactNode;
  variables: EmploymentQueryVariables;
}) => ReactElement;

export const EmploymentQueryProvider: EmploymentQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<EmploymentQueryType, EmploymentQueryVariables>(EmploymentQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
